import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const load = (k, d) => {
  try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; }
};

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => load("alfaz_cart", []));
  const [profile, setProfile] = useState(() => load("alfaz_profile", { name: "", phone: "" }));
  const [history, setHistory] = useState(() => load("alfaz_orders", []));

  useEffect(() => localStorage.setItem("alfaz_cart", JSON.stringify(items)), [items]);
  useEffect(() => localStorage.setItem("alfaz_profile", JSON.stringify(profile)), [profile]);
  useEffect(() => localStorage.setItem("alfaz_orders", JSON.stringify(history)), [history]);

  const value = useMemo(() => {
    const add = (it) => {
      const key = `${it.menu_id}|${it.option}|${it.note}`;
      setItems((prev) => {
        const ex = prev.find((p) => p.key === key);
        if (ex) return prev.map((p) => (p.key === key ? { ...p, qty: p.qty + it.qty } : p));
        return [...prev, { ...it, key }];
      });
    };
    const setQty = (key, qty) =>
      setItems((prev) => (qty <= 0 ? prev.filter((p) => p.key !== key) : prev.map((p) => (p.key === key ? { ...p, qty } : p))));
    const count = items.reduce((s, i) => s + i.qty, 0);
    const total = items.reduce((s, i) => s + i.qty * i.unit_price, 0);
    const addHistory = (id) => setHistory((h) => [id, ...h.filter((x) => x !== id)].slice(0, 30));
    return { items, add, setQty, clear: () => setItems([]), count, total, profile, setProfile, history, addHistory };
  }, [items, profile, history]);

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
